/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesPlayGameIframeGameConfigOptions, FxIdWebFeaturesPlayGameIframeGameConfigOptionsFromJSONTyped, FxIdWebFeaturesPlayGameIframeGameConfigOptionsToJSON, } from './FxIdWebFeaturesPlayGameIframeGameConfigOptions';
export function FxIdWebFeaturesPlayGameResponseIframeGameFromJSON(json) {
    return FxIdWebFeaturesPlayGameResponseIframeGameFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseIframeGameFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesPlayGameIframeGameConfigOptions(json)) {
        return FxIdWebFeaturesPlayGameIframeGameConfigOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesPlayGameResponseIframeGameToJSON(json) {
    return FxIdWebFeaturesPlayGameResponseIframeGameToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseIframeGameToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesPlayGameIframeGameConfigOptions(value)) {
        return FxIdWebFeaturesPlayGameIframeGameConfigOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesPlayGameResponseIframeGame.js.map